export enum FontMood {
    'rustic' = 0,
    'sturdy' = 1,
    'mechanical' = 2,
    'industrial' = 3,
    'informal' = 4,
    'contemporary' = 5,
    'high-tech' = 6,
    'futuristic' = 7,
    'lively' = 8,
    'delicate' = 9,
    'classical' = 10,
    'formal' = 11,
    'cute' = 12,
    'fun' = 13,
    'technical' = 14,
    'retro' = 15,
    'friendly' = 16,
    'digital' = 17,
}
